<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
(function () {
  function initCustomHeight(root) {
    (root || document).querySelectorAll('[data-ch-scope]').forEach(function (box) {
      if (box.dataset.chInit === '1') return;
      box.dataset.chInit = '1';
      var ctrl = box.querySelector('.height-customization');
      var picker = box.querySelector('[data-ch-picker]');
      var form = box.closest('form');
      var heightSelect = picker && picker.querySelector('select');
      if (!ctrl || !picker) return;
      function toggle(){ var show = ctrl.value === 'Yes'; picker.hidden = !show; if(!show && heightSelect) heightSelect.value=''; }
      ctrl.addEventListener('change', toggle); toggle();
      if (form) form.addEventListener('submit', function(e){
        if (ctrl.value === 'Yes' && heightSelect && !heightSelect.value){ e.preventDefault(); alert('Please select your height.'); heightSelect.focus(); }
      }, true);
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ initCustomHeight(document); });
  document.addEventListener('shopify:section:load', function(e){ initCustomHeight(e.target); });
})();
{{ 'custom.js' | asset_url | script_tag }}


(function () {
  function initCustomHeight(root) {
    (root || document).querySelectorAll('[data-ch-scope]').forEach(function (box) {
      if (box.dataset.chInit === '1') return;
      box.dataset.chInit = '1';

      var form        = box.closest('form');
      var ctrl        = box.querySelector('.height-customization');   // Yes/No
      var pickerWrap  = box.querySelector('[data-ch-picker]');
      var heightSelect= pickerWrap && pickerWrap.querySelector('select');
      if (!form || !ctrl || !pickerWrap || !heightSelect) return;

      // Collect buttons by your actual markup
      function collectButtons() {
        var atc = Array.from(form.querySelectorAll(
          '#product-add-to-cart, button.product-form__submit[name="add"]'
        ));
        var payWrap = form.querySelector('.shopify-payment-button');
        return { atc, payWrap };
      }
      var buttons = collectButtons();

      function setDisabled(disabled) {
        buttons.atc.forEach(function (b) {
          b.disabled = disabled;
          b.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          b.classList.toggle('is-disabled', disabled);
        });
        if (buttons.payWrap) buttons.payWrap.style.display = disabled ? 'none' : '';
      }

      function toggle() {
        var wantsCustom = ctrl.value === 'Yes';
        pickerWrap.hidden = !wantsCustom;
        heightSelect.required = wantsCustom;

        if (!wantsCustom) {
          heightSelect.value = '';
          setDisabled(false);
          return;
        }
        setDisabled(!heightSelect.value);
      }

      // Wire up
      ctrl.addEventListener('change', toggle);
      heightSelect.addEventListener('change', toggle);

      // Re-detect if theme swaps buttons on variant change
      form.addEventListener('change', function (e) {
        if (e.target && e.target.name && e.target.name.indexOf('options') === 0) {
          buttons = collectButtons();
          toggle();
        }
      });

      // Initial + submit safety
      toggle();
      form.addEventListener('submit', function (e) {
        if (ctrl.value === 'Yes' && !heightSelect.value) {
          e.preventDefault();
          heightSelect.focus();
        }
      }, true);
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ initCustomHeight(document); });
  document.addEventListener('shopify:section:load', function(e){ initCustomHeight(e.target); });
})();